module.exports = __webpack_public_path__ + "img/mini-011.89b0b97c.jpg";